<div *ngFor="let step of bookingSteps; let i = index">
  <div
    class="booking-step"
    [class.inactive-step]="!step.isActive"
    [class.is-completed]="step.isCompleted"
    [class.is-failed]="step.isFailed"
    [class.is-last]="step.isLastStep"
    [class.compact]="strategy.useInlineTimer"
    *ngIf="step.isVisible"
  >
    <div class="status-circle" (click)="logStep(step)"></div>
    <div [class.status-bar]="step.continueTimeline"></div>

    <div class="flex-inner">
      <!-- Title -->
      <div class="step-title">
        {{ step.title }}
      </div>

      <!-- Subtitle -->
      <div class="step-desc" *ngIf="!step.isSubtitleHidden">
        <span class="me-1" [class.failed-step]="step.isFailed">{{ step.subtitle }}</span>
        <span class="inline-link" *ngIf="step.actionInfo && step.isActionCollapsed">
          <a
            [id]="'showTimelineActionLink_' + step.actionInfo.name"
            class="href"
            (click)="selectAction.emit(step.actionInfo)"
            >{{ step.actionInfo.callToAction }}</a
          >
        </span>
      </div>

      <!-- Call to action -->
      <div class="cta" *ngIf="step.actionInfo && !step.isActionCollapsed">
        <!-- Storage timer -->
        <div *ngIf="step.isActive && step.actionInfo.displayTimer && strategy.useInlineTimer">
          <lh-storage-timer
            [booking]="booking"
            [isCheckInSession]="isCheckInSession"
            [compactMode]="true"
            [largeDigits]="true"
          ></lh-storage-timer>
        </div>

        <span>
          <!-- Primary action button -->
          <button
            [id]="'showTimelineActionButton_' + step.actionInfo.name"
            class="btn btn-primary btn-lg"
            [disabled]="step.actionInfo.disabled"
            (click)="selectAction.emit(step.actionInfo)"
          >
            <span class="cta-text">{{ step.actionInfo.callToAction }}</span>
          </button>

          <!-- Skip action link -->
          <span *ngIf="step.actionInfo.skipAction">
            <a
              [id]="'skipTimelineActionLink_' + step.actionInfo.name"
              class="href inline-link skip enlarged"
              (click)="skipAction.emit(step.actionInfo)"
            >
              {{ step.actionInfo.skipText || ('SKIP' | translate) }}
            </a>
          </span>
        </span>
      </div>
    </div>
  </div>
</div>
